

import { atom, selector, selectorFamily } from "recoil"
import { ActivityInfoModel, AnswerPaperModel, QuestionModel, QuestionnaireModel } from "./typing"
import { questionList, activityInfo, submitAnswer } from "@/utils/api"
import { activityId } from "@/App"
import { CError } from "@/utils/server"
import { Matomo, Tracking } from "@/utils/tracking"




export type UserSelectedIdsType = {
  [key: string]: string[]
}

export const userSelectedIdsState = atom<UserSelectedIdsType>({
  key: 'userSelectedIdsState',
  default: {}
})


export type QuizType = {
  index: number
  image: string
  alert: boolean
  visible: boolean
  navigate: boolean
  alertType: string
  questionList: QuestionModel[]
  questionnaire: QuestionnaireModel | undefined
}

export const defaultQuizState: QuizType = {
  index: 0,
  image: '',
  alert: false,
  visible: false,
  navigate: false,
  alertType: '',
  questionList: [],
  questionnaire: undefined,
}

export const quizState = atom<QuizType>({
  key: 'quizState',
  default: defaultQuizState
})



export const fetchActivityInfoState = selector<ActivityInfoModel>({
  key: 'fetchActivityInfoState',
  get: async ({ get }) => {
    const [e, r] = await activityInfo<ActivityInfoModel>({ "aid": get(activityId) })
    if (r !== undefined) {
      Tracking.PV(r.data.uid, r.data.client_ip ?? "")
      Tracking.UA(r.data.uid, r.data.client_ip ?? "")
      Matomo(r.data.uid)
      return r.data
    }
    if (e !== undefined) {
      throw new Error(e.data.msg as string)
    }
    throw new Error('数据异常')
  },
})


type QuestionListProps = {
  [key: string]: string
}

export const fetchQuestionListState = selectorFamily<QuestionModel[], QuestionListProps>({
  key: 'fetchQuestionListState',
  get: (props) => async () => {
    const [e, r] = await questionList<QuestionModel[]>(props)
    if (r !== undefined) {
      return r.data
    }
    if (e !== undefined) {
      throw new CError(e.data.msg as string, e.data.code as number)
    }
    throw new Error('数据异常')
  },
})


const assembleAnswerResult = (questionList: QuestionModel[], userSelectedIds: UserSelectedIdsType) => {
  const result = questionList.map((question) => {
    const userSelectedIdsOfQuestion = userSelectedIds[question.question_id]
    if (userSelectedIdsOfQuestion === undefined || userSelectedIdsOfQuestion.length === 0) {
      return `${question.question_id}__0`
    } else {
      return `${question.question_id}__${userSelectedIdsOfQuestion.join('_')}`
    }
  })
  return result.join(',')
}


export const submitAmswerState = selector<AnswerPaperModel>({
  key: 'submitAmswerState',
  get: async ({ get }) => {
    const quiz = get(quizState)
    const answers = assembleAnswerResult(quiz.questionList, get(userSelectedIdsState))
    const [e, r] = await submitAnswer<AnswerPaperModel>({}, {
      "aid": get(activityId),
      "questionnaire_id": quiz.questionnaire?.questionnaire_id ?? '',
      "answers_list": answers
    }) 
    if (r !== undefined) {
      return r.data
    }
    if (e !== undefined) {
      throw new CError(e.data.msg as string,e.data.code)
    }
    throw new CError('数据异常',0)
  },
})




